<script setup lang="ts">
const props = defineProps<{
  trustedBy: {
    title: string;
    enterpriseImages: Record<string, { image: string; alt: string }>;
  };
  themeKeys: {
    title: string;
  };
}>();
</script>

<template>
  <div class="outer-container">
    <div class="inner-container">
      <h3
        class="w-full text-center text-3xl font-semibold mb-12 xl:mb-18 pt-12 xl:pt-18"
        :style="{ color: props.themeKeys.title }"
      >
        {{ props.trustedBy.title }}
      </h3>
      <div class="max-w-4xl mx-auto p-8 md:p-0 flex flex-row flex-wrap justify-between *:max-w-1/4 gap-16">
        <div
          v-for="image in Object.values(props.trustedBy.enterpriseImages)"
          :key="image.image"
          class="w-full h-fit"
        >
          <NuxtImg
            class="w-full aspect-16/9 object-contain saturate-10"
            :src="image.image"
            :alt="image.alt"
          />
        </div>
      </div>
    </div>
  </div>
</template>
